const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})

function miniCartWork(cartButton) {
  freeGiftCheck();
  $(cartButton).attr("disabled", false);
  $("body").css('overflow', 'hidden'); 
  $(".mini-cart").addClass("mini-cart active-cart");
  $(".vertical-scroll-bar").show();
  $(".check-box").show();
  $(".empty-cart-message").hide();
  $("#checkout-btn").css({ opacity: "1" });
  $("#checkout-btn").css({ pointerEvents: "unset" });
  $("#clear-btn").css('display', 'block');
}

//START --- Simple cart functions
async function itemAddToCart(itemId, qty) {
  let formData = {
    items: [{
     id: itemId,
     quantity: qty
    }]
  };
  await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  getThemeCartDetails();
  setTimeout(freeGiftCheck, 1000);
}

function itemGiftClear(id){
  let formData = {
     id: id, 
     quantity: 0 
  }
  $.ajax({
    type: "POST",
    url: '/cart/change.js',
    data: formData,
    dataType: 'json',
    success: function(e) { 
      console.log(e)
      $(`[data-vid='${id}']`).parent().parent().remove();
    },
    error: function(XMLHttpRequest, textStatus) {
      
    }
  });
}
//END --- Simple cart functions

async function freeGiftCheck() {
  document.querySelector('#checkout-btn').setAttribute('disabled', 'disabled');
  const response = await fetch('/cart.js');
  let cartData = await response.json();

  let cartTotalPrice = +`${cartData.total_price/100}`;
  let cartProductPoint = document.querySelectorAll('.prodress-bar-product-point');
  cartProductPoint.forEach(item => {
    let itemPrice = +item.getAttribute('data-point-price'),
    itemVariantId = +item.getAttribute('data-point-variant-id');
    if (cartTotalPrice >= itemPrice) {
      if (cartData.items.find(element => element.id === itemVariantId) == undefined && document.querySelector(`.this-is-free-gift--${itemVariantId}`) == null) {
        //itemAddToCart(itemVariantId, 1);
      }
    } else if (cartTotalPrice < itemPrice) {
      if (cartData.items.find(element => element.id === itemVariantId) != undefined) {
        //remove the product if the API didn't work
        itemGiftClear(itemVariantId);
        console.log('the product has been removed');
      }
    } else {
      console.log('CART TOTAL PRICE: ' + cartTotalPrice);
      console.log('ITEM PRICE: ' + itemPrice);
    }
  });
  //cart progress bar - active circles
  let cartBarPoints = document.querySelectorAll('.mini-cart__progress-bar-point');
  cartBarPoints.forEach(item => {
    let itemPrice = +item.getAttribute('data-point-price');
    if (cartTotalPrice >= itemPrice) {
      item.classList.add('point-active');
    } else {
      item.classList.remove('point-active');
    }
  });

  let cartBarActivePoints = document.querySelectorAll('.point-active'),
  cartProgressBar = document.querySelector('.mini-cart__progress-bar-value'),
  cartProgressBarText = document.querySelector('.mini-cart__progress-bar-text');
  if (cartBarPoints.length > 2 && cartBarActivePoints.length == cartBarPoints.length - 1) {
    cartProgressBar.style.width = `calc(${cartBarActivePoints.length * 100 / cartBarPoints.length}% + ${30 / cartBarPoints.length}px)`;
  } else {
    cartProgressBar.style.width = `${cartBarActivePoints.length * 100 / cartBarPoints.length}%`;
  }

  if (cartBarActivePoints.length < cartBarPoints.length) {
    cartProgressBarText.style.display = 'block';
    let nextPointPrice = +cartBarPoints[cartBarActivePoints.length].getAttribute('data-point-price'),
    nextPointText = cartBarPoints[cartBarActivePoints.length].getAttribute('data-point-text'),
    onlyPrice = nextPointPrice - cartTotalPrice;
    document.querySelector('#bar-price').textContent = `$${onlyPrice.toFixed(2)}`;
    document.querySelector('#bar-text').textContent = `FREE ${nextPointText}`;
  } else {
    cartProgressBarText.style.display = 'none';
  }

  getThemeCartDetails();
  document.querySelector('#checkout-btn').removeAttribute('disabled', false);

  window.getCartInfo();
}
freeGiftCheck();

async function addToCart(variantId,qty,id) {
  let cartButton = document.getElementById(id);
  cartButton.setAttribute('disabled', true)

  let items = [];
  if (cartButton.hasAttribute('data-delivery-text')) {
    let properties = {
        'Note': `Pre Order - ${cartButton.getAttribute('data-delivery-text')}`
    }
    items.push({id: variantId, quantity: qty, properties});
  } else {
      items.push({id: variantId, quantity: qty});
  }
  let formData = {items};

  await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });

  miniCartWork(cartButton);
}

async function updateCart(variantId,qty){
  console.log('object');
  const itemUp =
  {
    updates: {
      [variantId]: qty,
    }
  }
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
      body: JSON.stringify(itemUp)
    })
    .then(response => {
      return response.json()
    })
    .then((state)=> {
      let data = state.items.length>0&&state.items.filter(item=>{
        return item.id==variantId
      })
      let updatedVariantPrice = data[0].final_line_price / 100
      updatedVariantPrice = formatter.format(updatedVariantPrice)
      console.log( $(`[data-prod-sku='${data[0].sku}']:eq(1)`).text(updatedVariantPrice));
      let total_discount = cartData.total_discount;
      if(total_discount <= 0){
        document.getElementById('original_total_price').style.display = "none";
      } else {
        document.getElementById('original_total_price').style.display = "block";
        document.getElementById('original_total_price').innerHTML = `$${(cartData.original_total_price/100).toFixed(2)}`;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });

  await getThemeCartDetails("update");
}

async function getThemeCartDetails(type="get"){
  type == "get" && $('.vertical-scroll-bar').children('.product-details-cart').remove();
  const response = await fetch('/cart.js')
  cartData = await response.json();
  cartData.items.length > 0  ?  $('#clear-btn').css('display','block') : $('#clear-btn').css('display','none');
  let freeItems = [];
  let cartProductPoint = document.querySelectorAll('.prodress-bar-product-point');
  for (let add = 0; add < cartProductPoint.length; add++) {
    freeItems.push(+cartProductPoint[add].getAttribute('data-point-variant-id'));
  }
  type == "get" && cartData.items.forEach((element,index) => {
    if (freeItems.includes(element.id) || element.title.includes('FREE GIFT')) {
        $('.vertical-scroll-bar').append(`<div class="product-details-cart this-is-free-gift--${element.id} item--${element.id}">
          <a class="remove_btn">
            <img data-vId="${element.id}" src="https://cdn.shopify.com/s/files/1/0593/4317/5847/files/icon-close.png?v=1663149370" alt="remove"/>
          </a>
          <div class="img-svg">
            <img src="${element.image}" class="imgimgimg" alt="item"/>
          </div>
    
          <div class="artical-details">
            <p class="my-0" class="product-title">${element.title}</p>
                <div class="counter-details">
                  <h4>$${(element.final_line_price/100).toFixed(2)}</h4>
                </div>
              </div>
            </div>`);
    } else {
      if (element.properties['Note'] !== undefined) {
        $('.vertical-scroll-bar').append(`<div class="product-details-cart item--${element.id}">
        <a class="remove_btn" onclick="setTimeout(freeGiftCheck, 1500);">
          <img data-vId="${element.variant_id}" src="https://cdn.shopify.com/s/files/1/0593/4317/5847/files/icon-close.png?v=1663149370" alt="remove"/>
        </a>
        <div class="img-svg">
          <img src="${element.image}" class="imgimgimg" alt="item"/>
        </div>
  
        <div class="artical-details">
          <p class="my-0" class="product-title">${element.title}</p>
          <div class='hulkapps-reminder' data-key="${element.key}"></div>
              <div class="counter-details">
                <div class="counter">
                <button id="cart-inc-btn" class="button extra count-minus" onclick="cartDecrement('${index}','${element.variant_id}');">-</button>
                  <input id=${index} min="1" onchange="handleInputCheck('${index}','${element.variant_id}');" class="counter_mini btn-check" type="number" value=${element.quantity}>
                  <button class="button extra count-plus" onclick="cartIncrement('${index}','${element.variant_id}');">+</button>
                </div>
                <h4 data-hulkapps-line-price data-key="${element.key}">${(element.final_line_price/100).toFixed(2)}</h4>
              </div>
              <span class="pre-order-note">${element.properties['Note']}</span>
            </div>
          </div>`);
      } else {
        $('.vertical-scroll-bar').append(`<div class="product-details-cart item--${element.id}">
        <a class="remove_btn" onclick="setTimeout(freeGiftCheck, 1500);">
          <img data-vId="${element.variant_id}" src="https://cdn.shopify.com/s/files/1/0593/4317/5847/files/icon-close.png?v=1663149370" alt="remove"/>
        </a>
        <div class="img-svg">
          <img src="${element.image}" class="imgimgimg" alt="item"/>
        </div>
  
        <div class="artical-details">
          <p class="my-0" class="product-title">${element.title}</p>
          <div class='hulkapps-reminder' data-key="${element.key}"></div>
              <div class="counter-details">
                <div class="counter">
                <button id="cart-inc-btn" class="button extra count-minus" onclick="cartDecrement('${index}','${element.variant_id}');">-</button>
                  <input id=${index} min="1" onchange="handleInputCheck('${index}','${element.variant_id}');" class="counter_mini btn-check" type="number" value=${element.quantity}>
                  <button class="button extra count-plus" onclick="cartIncrement('${index}','${element.variant_id}');">+</button>
                </div>
                <h4 data-hulkapps-line-price data-key="${element.key}">${(element.final_line_price/100).toFixed(2)}</h4>
              </div>
            </div>
          </div>`);
      }
        
    }
  });

  let total_discount = cartData.total_discount;
  document.getElementById('cart_count1').innerHTML = ` ${cartData.item_count}`;
  if(total_discount <= 0) {
    document.getElementById('original_total_price').style.display = "none";
  } else {
    document.getElementById('original_total_price').style.display = "block";
    document.getElementById('original_total_price').innerHTML = `$${(cartData.original_total_price/100).toFixed(2)}`;
  }
  document.getElementById('cart_count').innerHTML = ` ${cartData.item_count}`;
  document.getElementById('total_price').innerHTML = `<span data-hulkapps-cart-total>$${(cartData.total_price/100).toFixed(2)}</span>`;
  $('.totals__subtotal-value').text(`$${cartData.total_price/100}.00 USD `);
  var setRefresh = setInterval(function(){
    var priceLength = $('body').find('.after_discount_price .final-total').length;
    if(priceLength > 0){
      var discountedPrice = $('body').find('.after_discount_price').text().split('$')[1];
      if($('.discountedPrice').length > 0){
        $('body').find('#total_price .discountedPrice').text('$'+ discountedPrice);        
      }
      else{
        $('body').find('#total_price').append('<span class="discountedPrice"></span>'); 
        $('body').find('#total_price .discountedPrice').text('$'+ discountedPrice); 
      }
      $('body').find('.after_discount_price').text('');
      clearInterval(setRefresh);
    }
  },5);
}

window.addEventListener('load', getThemeCartDetails);

const $menu = $('.mini-cart');
$(document).mouseup(e => {
  if (!$menu.is(e.target) // if the target of the click isn't the container...
    && $menu.has(e.target).length === 0) // ... nor a descendant of the container
  {
    $("body").css( "overflow",'auto' );
     $menu.removeClass('active-cart');
  }
});

var cartCalculateTimeout = 1000;
var cartCalculateLastCall = null;
function cartCalculate(id,pid) {
    if((Date.now() - cartCalculateLastCall) >= cartCalculateTimeout) {
      updateCart(pid,document.getElementById(id).value);
      let total_discount = cartData.total_discount;
      if (total_discount <= 0) {
        document.getElementById('original_total_price').style.display = "none";
      } else {
        document.getElementById('original_total_price').style.display = "block";
        document.getElementById('original_total_price').innerHTML = `$${(cartData.original_total_price/100).toFixed(2)}`;
      }
      setTimeout(freeGiftCheck, 1000);
    }
}
function cartIncrement(id,pid) {
  document.querySelector('#checkout-btn').setAttribute('disabled', 'disabled');
  document.getElementById(id).stepUp();
  cartCalculateLastCall = new Date();
  setTimeout(cartCalculate, cartCalculateTimeout, id, pid);
}
function cartDecrement(id,pid) {
  document.querySelector('#checkout-btn').setAttribute('disabled', 'disabled');
  document.getElementById(id).stepDown();
  cartCalculateLastCall = new Date();
  setTimeout(cartCalculate, cartCalculateTimeout, id, pid);
}
 
function clearcart(){
    let formData = {
      items: [{
       id: null,
       quantity: null 
       }]
    }
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: formData,
      dataType: 'json',
      success: function() { 
        $('.vertical-scroll-bar').children('.product-details-cart').remove();
        document.getElementById('cart_count').innerHTML = 0;
        document.getElementById('cart_count1').innerHTML = 0;
        $(".vertical-scroll-bar").hide();
        $(".check-box").hide();
        $(".empty-cart-message").show();
        $("#checkout-btn").prop("disabled", true);
        $("#checkout-btn").css({ opacity: "0.5" });
        $("#checkout-btn").css({ pointerEvents: "none" });
        $("#clear-btn").css('display','none');
        document.getElementById('original_total_price').style.display = "none";
        document.getElementById('total_price').innerHTML = `$${(0).toFixed(2)}`;
        setTimeout(freeGiftCheck, 1000);
      },
      error: function(XMLHttpRequest, textStatus) {
      }
    });
  return false;
}

function clearOne(event,id){
    let formData = {
       id: id, 
       quantity: 0 
    }
    $.ajax({
      type: "POST",
      url: '/cart/change.js',
      data: formData,
      dataType: 'json',
      success: function(e) { 
        console.log(e)
        $(`[data-vid='${id}']`).parent().parent().remove();
        document.getElementById('cart_count').innerHTML = ` ${e.item_count}`;
        let cart_count = e.item_count;
        if(cart_count == 0){
          $(".vertical-scroll-bar").hide();
          $(".check-box").hide();
          $(".empty-cart-message").show();
          $("#checkout-btn").css({ opacity: "0.5" });
          $("#checkout-btn").css({ pointerEvents: "none" });
          $("#clear-btn").css('display', 'none');
          document.getElementById('original_total_price').style.display = "none";
        }
        document.getElementById('total_price').innerHTML = `<span data-hulkapps-cart-total>$${(e.total_price/100).toFixed(2)}</span>`;
      },
      error: function(XMLHttpRequest, textStatus) {
      }
    });
    return false;
}

$(document).on('click','.remove_btn',function(e){
    let vId = $(e.target).data('vid');
    clearOne(e,vId);
    getThemeCartDetails();
});

async function updateGiftMsg(msg){
    const itemUp = {
        note: msg
    }   
  
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
            body: JSON.stringify(itemUp)
          })
          .then(response => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
  
    await getThemeCartDetails();
       
}

function handleInputCheck(id,vId){
  document.querySelector('#checkout-btn').setAttribute('disabled', true);
  if (document.getElementById(id).valueAsNumber <= 0 || document.getElementById(id).value == '') {
    document.getElementById(id).value = 1;
  }
  updateCart(vId,document.getElementById(id).valueAsNumber);
  setTimeout(freeGiftCheck, 1000);
}
$("#checkout-btn").click(async function() {
  let mesg = document.getElementById('messageBox').value
  document.getElementById('cbox').checked && document.getElementById('messageBox').value !== '' && updateGiftMsg(mesg)
});

//ADD TO CART LOGIC FOR PRODUCT
let checkBtns = document.querySelectorAll('button.uncheck');
for (let btn of checkBtns) {
  btn.addEventListener('click', ()=> {
    btn.classList.toggle('check');
    btn.closest('.spice-kit-section-right-addOns-card').classList.toggle('check-product');
  });
}